import React, { useEffect, useState } from "react";
import { Carousel } from "primereact/carousel";
import "./style.css";
import "./style-lp.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import ImageGeneric from "../../content/img/generic.png";
import { useHistory } from "react-router-dom";
import { Evento } from "passemix-lib/src/models/Evento";
import { EventoService } from "../../services/EventoService";
import { UtilsHelper } from "passemix-lib/src/helpers/UtilsHelper";

export interface IHomeComponent {}

const HomeComponent: React.FC<IHomeComponent> = (props) => {
  const history = useHistory();
  const [eventos, setEventos] = useState<Evento[]>(new Array<Evento>());

  const carregaEventos = async () => {
    try {
      let service = new EventoService();
      let response = await service.obterEventosLoja();

      setEventos(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    carregaEventos();
    document.querySelectorAll(".faq-q").forEach((btn) => {
      btn.addEventListener("click", () => {
        const item = btn.closest(".faq-item");
        const isOpen = item!.classList.contains("open");
        document.querySelectorAll(".faq-item").forEach((i) => {
          i.classList.remove("open");
          i.querySelector(".faq-q")!.setAttribute("aria-expanded", "false");
        });
        if (!isOpen) {
          item!.classList.add("open");
          btn.setAttribute("aria-expanded", "true");
        }
      });
    });
    document.querySelectorAll<HTMLElement>(".tab-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const tab = btn.dataset.tab;
        document.querySelectorAll(".tab-btn").forEach((b) => {
          b.classList.remove("active");
          b.setAttribute("aria-selected", "false");
        });
        document
          .querySelectorAll(".tab-content")
          .forEach((c) => c.classList.remove("active"));
        btn.classList.add("active");
        btn.setAttribute("aria-selected", "true");
        document.getElementById("tab-" + tab)!.classList.add("active");
      });
    });
  }, []);

  const responsiveOptions = [
    {
      breakpoint: "1024px",
      numVisible: 3,
      numScroll: 3,
    },
    {
      breakpoint: "600px",
      numVisible: 2,
      numScroll: 2,
    },
    {
      breakpoint: "480px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  const eventoBannerTemplate = (evento) => {
    return evento.imagem ? (
      <div
        className="img-banner-carousel-evento"
        style={{
          backgroundImage: `url(${
            evento.imagem
              ? `https://passemix-assets.s3.amazonaws.com/eventos/${evento.imagem}`
              : ImageGeneric
          })`,
        }}
        onClick={() => history.push(`/${evento.url}`)}
      ></div>
    ) : (
      ""
    );
  };

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <>
      {/* SEÇÃO 1 — HERO / BANNER PRINCIPAL */}
      <section id="hero" aria-label="Apresentação da Passemix">
        <div className="container-lp">
          <div className="hero-inner">
            <div className="hero-copy">
              <div className="hero-badge">
                Tecnologia de pagamentos para eventos
              </div>
              <h1>
                A tecnologia certa para venda de ingressos em eventos.
                <br />
              </h1>
              <p className="hero-desc">
                Da bilheteria online ao caixa móvel com maquininha de cartão — a
                Passemix centraliza tudo para o seu evento vender mais com
                controle total.
              </p>
              <div className="hero-ctas">
                <a href="#contato" className="btn btn-primary">
                  Quero uma demonstração
                </a>
                <a href="#como-funciona" className="btn btn-ghost">
                  Ver como funciona
                </a>
              </div>
              <div className="hero-chips">
                <span className="hero-chip">🎟 Ingressos online</span>
                <span className="hero-chip">💳 Maquininha de cartão</span>

                <span className="hero-chip">📊 Relatórios em tempo real</span>
              </div>
            </div>
            <div className="hero-stats" aria-hidden="true">
              <div className="stat-card">
                <div className="stat-icon">🎟</div>
                <div>
                  <div className="stat-val">+500</div>
                  <div className="stat-lbl">eventos realizados</div>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">💰</div>
                <div>
                  <div className="stat-val">R$ 8M+</div>
                  <div className="stat-lbl">em vendas processadas</div>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">⭐</div>
                <div>
                  <div className="stat-val">98%</div>
                  <div className="stat-lbl">satisfação dos clientes</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* PROVA SOCIAL */}
      <div id="proof" aria-label="Números da Passemix">
        <div className="container-lp">
          <div className="proof-grid">
            <div className="proof-item">
              <div className="proof-num">+500</div>
              <div className="proof-desc">eventos realizados</div>
            </div>
            <div className="proof-item">
              <div className="proof-num">R$ 8M+</div>
              <div className="proof-desc">em vendas processadas</div>
            </div>
            <div className="proof-item">
              <div className="proof-num">+50 cidades</div>
              <div className="proof-desc">atendidas em Minas Gerais</div>
            </div>
          </div>
        </div>
      </div>

      {/* SEÇÃO 2 — COMO FUNCIONA */}
      <section id="como-funciona" aria-label="Como funciona a Passemix">
        <div className="container-lp">
          <div className="hiw-header">
            <div>
              <span className="section-eyebrow">Como funciona</span>
              <h2 className="section-title">
                Dois produtos integrados,
                <br />
                <em>uma plataforma só</em>
              </h2>
            </div>
            <div className="tabs" role="tablist" aria-label="Produtos Passemix">
              <button
                className="tab-btn active"
                role="tab"
                aria-selected="true"
                data-tab="online"
              >
                🎟 Venda online
              </button>
              <button
                className="tab-btn"
                role="tab"
                aria-selected="false"
                data-tab="maquininha"
              >
                💳 Maquininha + Ticket
              </button>
            </div>
          </div>

          {/* <!-- Tab: Venda Online --> */}
          <div className="tab-content active" id="tab-online" role="tabpanel">
            <div className="steps">
              <div className="step">
                <div className="step-num-wrap">
                  <div className="step-num">1</div>
                  <div className="step-line"></div>
                </div>
                <div className="step-body">
                  <div className="step-title">
                    Cadastre seu evento ou excursão
                  </div>
                  <div className="step-desc">
                    Configure ingressos por lote, capacidade máxima, datas e
                    formas de pagamento em poucos minutos.
                  </div>
                </div>
              </div>
              <div className="step">
                <div className="step-num-wrap">
                  <div className="step-num">2</div>
                  <div className="step-line"></div>
                </div>
                <div className="step-body">
                  <div className="step-title">Divulgue com link ou QR Code</div>
                  <div className="step-desc">
                    Compartilhe nas redes sociais ou incorpore no seu site. Os
                    compradores pagam por PIX ou cartão e o ingresso fica
                    disponível na plataforma com QR Code.
                  </div>
                </div>
              </div>
              <div className="step">
                <div className="step-num-wrap">
                  <div className="step-num">3</div>
                  <div className="step-line"></div>
                </div>
                <div className="step-body">
                  <div className="step-title">Valide na portaria com o app</div>
                  <div className="step-desc">
                    Leitura do QR Code pelo celular. Controle de acesso em tempo
                    real, sem papel, sem fila.
                  </div>
                </div>
              </div>
              <div className="step">
                <div className="step-num-wrap">
                  <div className="step-num">4</div>
                </div>
                <div className="step-body">
                  <div className="step-title">
                    Acompanhe o repasse financeiro
                  </div>
                  <div className="step-desc">
                    O saldo das vendas online fica disponível no painel com
                    transparência e prazos definidos conforme o plano
                    contratado.
                  </div>
                </div>
              </div>
            </div>
            <div className="hiw-visual" aria-hidden="true">
              <div className="vis-bar">
                <div className="vis-bar-dot"></div>
                <div className="vis-bar-label">Passemix — Painel do evento</div>
              </div>
              <div className="vis-row">
                <div className="vis-block">
                  <div className="vis-block-label">Ingressos disponível</div>
                  <div className="vis-block-val">1.247</div>
                </div>
                <div className="vis-block">
                  <div className="vis-block-label">Ingressos vendidos</div>
                  <div className="vis-block-val">1.500</div>
                </div>
              </div>
              <div className="vis-big">
                <div className="vis-big-label">Receita total</div>
                <div className="vis-big-val">R$ 24.380,00</div>
                <div className="vis-big-sub">↑ 18% vs. evento anterior</div>
              </div>
              <div className="vis-row">
                <div className="vis-block">
                  <div className="vis-block-label">Autenticados</div>
                  <div className="vis-block-val">1.190</div>
                </div>
                <div className="vis-block">
                  <div className="vis-block-label">
                    Ingressos de comissários
                  </div>
                  <div className="vis-block-val">1.190</div>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Tab: Maquininha + Ficha --> */}
          <div className="tab-content" id="tab-maquininha" role="tabpanel">
            <div className="steps">
              <div className="step">
                <div className="step-num-wrap">
                  <div className="step-num">1</div>
                  <div className="step-line"></div>
                </div>
                <div className="step-body">
                  <div className="step-title">
                    Configure a maquininha para o evento
                  </div>
                  <div className="step-desc">
                    A Passemix entrega a maquininha já configurada com os
                    valores de produtos do seu evento. Sem instalações
                    complicadas.
                  </div>
                </div>
              </div>
              <div className="step">
                <div className="step-num-wrap">
                  <div className="step-num">2</div>
                  <div className="step-line"></div>
                </div>
                <div className="step-body">
                  <div className="step-title">Operador recebe o pagamento</div>
                  <div className="step-desc">
                    O cliente paga por cartão de débito, crédito ou PIX direto
                    na maquininha. Aprovação em segundos.
                  </div>
                </div>
              </div>
              <div className="step">
                <div className="step-num-wrap">
                  <div className="step-num">3</div>
                  <div className="step-line"></div>
                </div>
                <div className="step-body">
                  <div className="step-title">
                    Sistema emite o ticket automaticamente
                  </div>
                  <div className="step-desc">
                    Após a aprovação do pagamento, o ticket físico é emitido na
                    mesma operação.
                  </div>
                </div>
              </div>
              <div className="step">
                <div className="step-num-wrap">
                  <div className="step-num">4</div>
                </div>
                <div className="step-body">
                  <div className="step-title">
                    Controle de caixa em tempo real
                  </div>
                  <div className="step-desc">
                    Cada venda aparece no painel na hora. Veja quantos tickets
                    foram emitidos, por qual operador e qual a receita
                    acumulada.
                  </div>
                </div>
              </div>
            </div>
            <div className="hiw-visual" aria-hidden="true">
              <div className="vis-bar">
                <div className="vis-bar-dot"></div>
                <div className="vis-bar-label">
                  Caixa móvel — Evento ao vivo
                </div>
              </div>
              <div className="vis-big">
                <div className="vis-big-label">Tickets emitidos hoje</div>
                <div className="vis-big-val">3.890</div>
                <div className="vis-big-sub">↑ Caixa funcionando</div>
              </div>
              <div className="vis-row">
                <div className="vis-block">
                  <div className="vis-block-label">Receita caixa</div>
                  <div className="vis-block-val">R$ 9.725</div>
                </div>
                <div className="vis-block">
                  <div className="vis-block-label">Operadores ativos</div>
                  <div className="vis-block-val">4 caixas</div>
                </div>
              </div>
              <div className="vis-row">
                <div className="vis-block">
                  <div className="vis-block-label">Cartão débito</div>
                  <div className="vis-block-val">62%</div>
                </div>
                <div className="vis-block">
                  <div className="vis-block-label">PIX</div>
                  <div className="vis-block-val">38%</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SEÇÃO 3 — FUNCIONALIDADES */}
      <section id="funcionalidades" aria-label="Funcionalidades da Passemix">
        <div className="container-lp">
          <span className="section-eyebrow">Funcionalidades</span>
          <h2 className="section-title">
            Tudo que você precisa
            <br />
            <em>em uma plataforma só</em>
          </h2>
          <p className="section-lead">
            Bilheteria, caixa móvel, controle de acesso e relatórios — sem
            precisar contratar múltiplos sistemas.
          </p>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🌐</div>
              <div className="feature-title">Venda online 24 horas</div>
              <div className="feature-desc">
                Página de vendas pronta com seu branding. Aceite PIX e cartão de
                crédito com parcelamento, em qualquer dispositivo.
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💳</div>
              <div className="feature-title">
                Maquininha de cartão para eventos
              </div>
              <div className="feature-desc">
                Maquininha integrada ao sistema de fichas. Aceite débito,
                crédito e PIX com emissão automática de ficha a cada transação.
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎟</div>
              <div className="feature-title">Ingressos com QR Code</div>
              <div className="feature-desc">
                Ingresso digital disponível na plataforma com QR Code. Validação
                rápida na portaria pelo app, sem internet obrigatória.
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🗓</div>
              <div className="feature-title">Gestão de qualquer evento</div>
              <div className="feature-desc">
                Shows, corridas, feiras, festas, baladas — configure e gerencie
                qualquer tipo de evento em uma única plataforma.
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <div className="feature-title">Controle de acesso</div>
              <div className="feature-desc">
                Impeça reentradas e fraudes. Cada QR Code é validado uma única
                vez, com registro de horário e operador.
              </div>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <div className="feature-title">Relatórios e dashboards</div>
              <div className="feature-desc">
                Receita, ticket médio, fichas emitidas e fluxo de caixa em tempo
                real. Exporte para Excel ao final do evento.
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SEÇÃO 4 — RELATÓRIOS DE VENDAS */}
      <section
        id="relatorios"
        aria-label="Relatórios de vendas e acompanhamento"
      >
        <div className="container-lp">
          <div className="reports-inner">
            <div className="reports-copy">
              <span className="section-eyebrow">
                Relatórios e acompanhamento
              </span>
              <h2 className="section-title">
                Seu evento sob
                <br />
                <em>controle total</em>
              </h2>
              <p className="section-lead">
                Dashboards com receita, ingressos vendidos, ticket médio e
                controle de caixa. Acesse do celular ou computador durante o
                evento.
              </p>
              <div className="report-perks">
                <div className="perk">
                  <div className="perk-icon">⚡</div>
                  <div className="perk-text">
                    <div className="pt">Dados em tempo real</div>
                    <div className="pd">
                      Cada venda aparece no painel em segundos, online e na
                      maquininha.
                    </div>
                  </div>
                </div>
                <div className="perk">
                  <div className="perk-icon">👥</div>
                  <div className="perk-text">
                    <div className="pt">Controle por operador</div>
                    <div className="pd">
                      Saiba exatamente quanto cada caixa vendeu e quem operou.
                    </div>
                  </div>
                </div>
                <div className="perk">
                  <div className="perk-icon">📤</div>
                  <div className="perk-text">
                    <div className="pt">Exportação para Excel</div>
                    <div className="pd">
                      Relatório completo exportável ao final do evento para
                      análise ou prestação de contas.
                    </div>
                  </div>
                </div>
                <div className="perk">
                  <div className="perk-icon">📱</div>
                  <div className="perk-text">
                    <div className="pt">Acesso pelo celular</div>
                    <div className="pd">
                      Acompanhe as vendas de qualquer lugar durante o evento.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="dashboard-mock" aria-hidden="true">
              <div className="dm-header">
                <div className="dm-title">Dashboard — Evento ao vivo</div>
                <div className="dm-badge">● Ao vivo</div>
              </div>
              <div className="dm-grid">
                <div className="dm-card">
                  <div className="dm-card-label">Receita total</div>
                  <div className="dm-card-val">R$ 24.380</div>
                  <div className="dm-card-sub">↑ 18% vs. anterior</div>
                </div>
                <div className="dm-card">
                  <div className="dm-card-label">Ingressos vendidos</div>
                  <div className="dm-card-val">1.247</div>
                  <div className="dm-card-sub">de 1.500 disponíveis</div>
                </div>
                <div className="dm-card">
                  <div className="dm-card-label">Fichas emitidas</div>
                  <div className="dm-card-val">3.890</div>
                  <div className="dm-card-sub">caixa móvel</div>
                </div>
                <div className="dm-card">
                  <div className="dm-card-label">Ingressos autenticados</div>
                  <div className="dm-card-val">1.190</div>
                  <div className="dm-card-sub">validados na portaria</div>
                </div>
              </div>
              <div className="dm-bar-row">
                <div className="dm-bar-item">
                  <div className="dm-bar-top">
                    <span>Cartão de débito</span>
                    <span>R$ 15.120</span>
                  </div>
                  <div className="dm-bar-bg">
                    <div className="dm-bar-fill" style={{ width: "62%" }}></div>
                  </div>
                </div>
                <div className="dm-bar-item">
                  <div className="dm-bar-top">
                    <span>PIX</span>
                    <span>R$ 9.260</span>
                  </div>
                  <div className="dm-bar-bg">
                    <div className="dm-bar-fill" style={{ width: "38%" }}></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SEÇÃO 5 — FAQ */}
      <section id="faq" aria-label="Perguntas frequentes sobre a Passemix">
        <div className="container-lp">
          <div className="faq-inner">
            <div className="faq-aside">
              <span className="section-eyebrow">Dúvidas frequentes</span>
              <h2 className="section-title">
                Perguntas
                <br />
                <em>frequentes</em>
              </h2>
              <p className="section-lead">
                Não encontrou o que precisava? Fale com um consultor da
                Passemix.
              </p>
              <a href="#contato" className="btn-blue">
                Falar com consultor →
              </a>
            </div>
            <div className="faq-list">
              <div className="faq-item">
                <button className="faq-q" aria-expanded="false">
                  A Passemix funciona para qualquer tipo de evento?
                  <span className="faq-icon" aria-hidden="true">
                    +
                  </span>
                </button>
                <div className="faq-a">
                  Sim. A Passemix atende corridas, corridas de bike, festas,
                  shows, excursões, feiras, baladas e qualquer situação onde
                  seja necessário emitir um ticket ou ficha com controle de
                  acesso. Seja um evento de 100 pessoas ou uma festa com 5.000
                  participantes.
                </div>
              </div>

              <div className="faq-item">
                <button className="faq-q" aria-expanded="false">
                  Como funciona a venda de ingressos online?
                  <span className="faq-icon" aria-hidden="true">
                    +
                  </span>
                </button>
                <div className="faq-a">
                  Você cadastra o evento, define lotes com quantidade e preço, e
                  recebe um link de vendas para divulgar. Os compradores pagam
                  por PIX ou cartão e o ingresso fica disponível na plataforma
                  com QR Code. Na portaria, o operador valida pelo app.
                </div>
              </div>

              <div className="faq-item">
                <button className="faq-q" aria-expanded="false">
                  Como a maquininha de cartão emite fichas no evento?
                  <span className="faq-icon" aria-hidden="true">
                    +
                  </span>
                </button>
                <div className="faq-a">
                  O operador de caixa usa a maquininha para receber o pagamento
                  por cartão ou PIX. Após a aprovação da transação, o sistema
                  emite automaticamente a ficha física correspondente ao valor
                  pago — tudo no mesmo equipamento, sem etapas separadas.
                </div>
              </div>

              <div className="faq-item">
                <button className="faq-q" aria-expanded="false">
                  Preciso comprar a maquininha ou posso alugar?
                  <span className="faq-icon" aria-hidden="true">
                    +
                  </span>
                </button>
                <div className="faq-a">
                  Oferecemos locação da maquininha por evento. Nosso time indica
                  a melhor configuração de acordo com o volume e frequência dos
                  seus eventos. A maquininha já chega configurada e pronta para
                  usar.
                </div>
              </div>

              <div className="faq-item">
                <button className="faq-q" aria-expanded="false">
                  Como funciona o repasse financeiro das vendas online?
                  <span className="faq-icon" aria-hidden="true">
                    +
                  </span>
                </button>
                <div className="faq-a">
                  O saldo das vendas online é disponibilizado após o evento, com
                  prazo definido conforme o plano contratado. Você acompanha o
                  extrato completo pelo painel com total transparência.
                </div>
              </div>

              <div className="faq-item">
                <button className="faq-q" aria-expanded="false">
                  A Passemix funciona para excursões com vários ônibus?
                  <span className="faq-icon" aria-hidden="true">
                    +
                  </span>
                </button>
                <div className="faq-a">
                  Sim. Você configura cada ônibus com capacidade e preço
                  independentes. O sistema gera lista de passageiros por veículo
                  e permite check-in digital no dia da saída.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SEÇÃO 6 — CONTATO / CAPTAÇÃO DE LEAD */}
      <section id="contato" aria-label="Formulário de contato e demonstração">
        <div className="container-lp">
          <div className="contact-inner">
            <div className="contact-copy">
              <span className="section-eyebrow">Fale com um especialista</span>
              <h2 className="section-title">
                Pronto para vender mais
                <br />
                no seu evento?
              </h2>
              <p className="section-lead">
                Entre em contato com um consultor da Passemix e receba uma
                proposta personalizada para o seu evento.
              </p>
              <div className="contact-channels">
                <a
                  href="https://wa.me/5535998768359"
                  target="_blank"
                  rel="noopener"
                  className="channel channel-link"
                >
                  <div className="channel-icon">💬</div>
                  <div>
                    <div className="channel-label">
                      WhatsApp — clique para conversar
                    </div>
                    <div className="channel-val">(35) 99876-8359</div>
                  </div>
                </a>
                <a
                  href="mailto:contato@passemix.com.br"
                  className="channel channel-link"
                >
                  <div className="channel-icon">✉️</div>
                  <div>
                    <div className="channel-label">E-mail</div>
                    <div className="channel-val">contato@passemix.com.br</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="grid">
        <a
          href="https://api.whatsapp.com/send/?phone=5535998768359"
          target="_blank"
          rel="noreferrer"
          className="botao-whatsapp"
        >
          <FontAwesomeIcon icon={faWhatsapp} style={{ marginTop: "14px" }} />
        </a>
      </div>
    </>
  );
};

export default HomeComponent;
